var React = require('react');

function ButtonShape04 (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"st3","d":"M38.89,76.23c24.22,1.3,73.74,2.22,108.86-2.56c24.02-3.27,28.11-9.85,29.36-30.96\n\tC178.17,24.77,173.78,8.05,148,3.6C117.05-1.73,43.26,2.01,24.62,6.44c-14,3.33-23.98,5.58-23.98,38.7\n\tC0.64,61.16,7.01,74.52,38.89,76.23z"}));
}

ButtonShape04.defaultProps = {"viewBox":"0 0 177.89 78.25"};

module.exports = ButtonShape04;

ButtonShape04.default = ButtonShape04;
